import * as React from "react";
import {Box, IconButton, Stack, Typography} from "@mui/material";

import { useNewsFeed } from "./hooks/useNewsFeed";
import EventDetailCardRender from "../event/EventDetailCardRender";
import {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Post from "../dashboard/Post";
import {ActualityCard} from "../index";
import ExpandlessPlaceholder from "../placeholder/ExpandlessPlacehoder";
import {useRole} from "../userInfo/hooks/useRole";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import CircularProgress from "@mui/material/CircularProgress";


const NewsFeed = ({setShowNav}) => {
  const { newsFeed, getNext, offset, maxOffset } = useNewsFeed();
  const [hasMore, setHasMore] = useState(true);
  const [anchor, setAnchor] = useState(0);
  const [showMoveUpButton, setShowMoveUpButton] = useState(false);
  const [showMoveDownButton, setShowMoveDownButton] = useState(true);
  const {mode} = useDarkMode();

  const moveUp = () => {
    const tempPosition = anchor - 1;
    const tempAnchor = 'anchor'+tempPosition;
    const anchorEl = document.getElementById(tempAnchor);
    if (anchorEl) {
      window.scrollTo({
        top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
        behavior: "smooth",
      });
      setAnchor(anchor - 1);
    }
    const nextPosition = tempPosition - 1;
    if (document.getElementById('anchor'+nextPosition) == null) {
      setShowMoveUpButton(false);
    } else {
      setShowMoveUpButton(true);
      setShowMoveDownButton(true);
    }
  };

    useEffect(() => {
      setShowNav(false);
    }, []);

  const moveDown = () => {
    const tempPosition = anchor + 1;
    const tempAnchor = 'anchor'+tempPosition;
    const anchorEl = document.getElementById(tempAnchor);
    if (anchorEl) {
      window.scrollTo({
        top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
        behavior: "smooth",
      });
      setAnchor(anchor + 1);
    }
    const nextPosition = tempPosition + 1;
    if (document.getElementById('anchor'+nextPosition) == null) {
      setShowMoveDownButton(false);
    } else {
      setShowMoveDownButton(true);
      setShowMoveUpButton(true);
    }

  };

  const fetchMoreData = () => {
    console.log('offset', offset);
    console.log('maxOffset', maxOffset);
    if (offset + 1 >= maxOffset + 1 || maxOffset == 1) {
      setHasMore(false);
      return;
    }
    getNext();
    setShowMoveDownButton(true);
  };

  const renderNewsFeed = () => {
    const final = [];
    final.push(<Post/>);
    final.push(  <Typography variant='h3' color={mode.settings.textColor3} sx={{marginBottom : 2}}>
      Mon fil d'actualités
    </Typography>)
    newsFeed.map((item, index) => {
       const indexInc = index + 1;
      switch (item.type) {
        case "event":
          final.push(
            <EventDetailCardRender theEvent={item} id={'anchor'+indexInc}/>
          );
          break;
        case "actuality":
          final.push(<ActualityCard actuality={item} showCommunityInfo={true} id={'anchor'+indexInc}/>);
          break;
        case "empty":
          final.push(<Typography color={mode.settings.textColor3} variant={'subtitle6'} id={'anchor'+indexInc}>Aucune actualité pour le moment.</Typography>);
          break;
        default:
          break;
      }
    });
    return final;
  };
  return (
    <Stack sx={{ maxWidth: 1020, minWidth: {lg : 1020} }} flexGrow={1}>
      <InfiniteScroll
          dataLength={newsFeed.length}
          next={() => fetchMoreData()}
          hasMore={hasMore}
          initialScrollY={false}
          loader={newsFeed.length > 0 ? <ExpandlessPlaceholder/> : <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '75vh',
              }}
          >
            <CircularProgress size={50}/>
          </Box>}
          endMessage={
            <p style={{ textAlign: "center" }}>
            </p>
          }
      >
        {newsFeed.length > 0 && renderNewsFeed()}
      </InfiniteScroll>
      {
        showMoveUpButton ?
            <Box sx={{position: 'fixed', right: 0, top: '25%'}}>
              <IconButton
                  className={'btn-gradient'}
                  sx={{
                    color: '#FFFFFF',
                    borderRadius: 0,
                    borderTopLeftRadius: '10%',
                    borderBottomLeftRadius: '10%'
                  }}
                  onClick={moveUp}
              >
                <ArrowUpwardIcon role="img" aria-label={"Remonter au bloc précédent"}/>
              </IconButton>
            </Box> : <div></div>
      }
      {
        showMoveDownButton ?
            <Box sx={{position: 'fixed', right: 0, top: '32%'}}>
              <IconButton
                  className={'btn-gradient'}
                  sx={{
                    color: '#FFFFFF',
                    borderRadius: 0,
                    borderTopLeftRadius: '10%',
                    borderBottomLeftRadius: '10%'
                  }}
                  onClick={moveDown}
              >
                <ArrowDownwardIcon role="img" aria-label={"Descendre au prochain bloc"}/>
              </IconButton>
            </Box>: <div></div>
      }
    </Stack>
  );
};

export default NewsFeed;
